"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M2 6.03a2 2 0 100 4 2 2 0 100-4zM14 6.03a2 2 0 100 4 2 2 0 100-4zM8 6.03a2 2 0 100 4 2 2 0 100-4z"];
//# sourceMappingURL=more.js.map